export const deslugify = (slug: string = ''): string => {
  return slug
    .replace(/(^.|-.|&.)/g, (m) => m.toLocaleUpperCase()) // Capitalize first letter of each word
    .replace(/-/g, ' ');
};
